export default __webpack_public_path__ + "static/media/Employee_details.cfc9ef17.xlsx";